var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2987 0.710215C12.9087 0.320215 12.2787 0.320215 11.8887 0.710215L6.99875 5.59022L2.10875 0.700215C1.71875 0.310215 1.08875 0.310215 0.69875 0.700215C0.30875 1.09021 0.30875 1.72022 0.69875 2.11022L5.58875 7.00022L0.69875 11.8902C0.30875 12.2802 0.30875 12.9102 0.69875 13.3002C1.08875 13.6902 1.71875 13.6902 2.10875 13.3002L6.99875 8.41021L11.8887 13.3002C12.2787 13.6902 12.9087 13.6902 13.2987 13.3002C13.6887 12.9102 13.6887 12.2802 13.2987 11.8902L8.40875 7.00022L13.2987 2.11022C13.6787 1.73022 13.6787 1.09022 13.2987 0.710215Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon2);
export default __webpack_public_path__ + "static/media/closeIcon2.317b8b6da892b57b25887055b64eec8a.svg";
export { ForwardRef as ReactComponent };